/* Null-safe display formatters shared across pages. */

const EM_DASH = "—";

function toDate(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** 'YYYY-MM-DD' (local). Returns '—' for null/invalid. */
export function formatDate(iso: string | null | undefined): string {
  const d = toDate(iso);
  if (!d) return EM_DASH;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** 'YYYY-MM-DD HH:MM' (local). Returns '—' for null/invalid. */
export function formatDateTime(iso: string | null | undefined): string {
  const d = toDate(iso);
  if (!d) return EM_DASH;
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(iso)} ${hh}:${mm}`;
}

/** Grouped integer/decimal. Returns '—' for null. */
export function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return EM_DASH;
  return n.toLocaleString("en-US");
}

/** USD currency, no fractional cents. Returns '—' for null. */
export function formatCurrency(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return EM_DASH;
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
}

/** e.g. '3.2d', or '—' for null. */
export function formatDays(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return EM_DASH;
  return `${n.toFixed(1)}d`;
}

/** e.g. '64 GPU'. Returns '—' for null amount. */
export function capacityLabel(
  amount: number | null | undefined,
  unit: string | null | undefined,
): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return EM_DASH;
  const u = unit?.trim();
  return u ? `${formatNumber(amount)} ${u}` : formatNumber(amount);
}
